var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nav active-users", attrs: { mode: _vm.activeMode } },
    [
      _c(
        "div",
        {
          staticClass: "active-users__preview",
          on: { click: _vm.onListToggle }
        },
        [
          _c(
            "div",
            {
              ref: "previewUserImgsRef",
              staticClass: "active-users__preview-profiles"
            },
            _vm._l(_vm.visibleConcurrentUsers, function(user) {
              return _c("ProfileImage", {
                key: user.EmployeeId,
                staticClass: "active-users__preview-profiles-item",
                attrs: {
                  imageSrc: user.EmployeeImage,
                  firstName: user.FirstName,
                  lastName: user.LastName
                }
              })
            }),
            1
          ),
          _c("Badge", {
            staticClass: "active-users__preview-count-badge",
            attrs: {
              text: "+" + _vm.hiddenUserCount,
              visible: _vm.hiddenUserCount > 0
            }
          }),
          _vm.hiddenUserCount > 0
            ? _c("span", { staticClass: "active-users__preview-count-text" }, [
                _vm._v("Active Users")
              ])
            : _vm._e()
        ],
        1
      ),
      _c("Popover", {
        attrs: {
          visible: _vm.listVisible,
          trackedRefName: "previewUserImgsRef",
          zIndex: 2500,
          offset: [0, 16],
          placement: "bottom"
        },
        on: { close: _vm.onCloseList },
        scopedSlots: _vm._u([
          {
            key: "popoverBody",
            fn: function() {
              return [
                _c("div", { staticClass: "active-users__total-users" }, [
                  _vm._v(" " + _vm._s(_vm.activeUserCount) + " Active Users ")
                ]),
                _c(
                  "ul",
                  { staticClass: "active-users__total-users-list" },
                  _vm._l(_vm.groupConcurrentUsers, function(user) {
                    return _c(
                      "li",
                      {
                        key: user.EmployeeId,
                        staticClass: "active-users__total-users-list-item"
                      },
                      [
                        _c("ProfileImage", {
                          attrs: {
                            imageSrc: user.EmployeeImage,
                            height: 50,
                            firstName: user.FirstName,
                            lastName: user.LastName
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass:
                              "active-users__total-users-list-item-name"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.nameFromArray(user.FirstName)) +
                                " " +
                                _vm._s(_vm.nameFromArray(user.LastName)) +
                                " "
                            )
                          ]
                        ),
                        user.locked
                          ? [
                              _c("i", {
                                staticClass:
                                  "active-users__locked-user icon icon-key",
                                on: {
                                  "mouse-over": function($event) {
                                    _vm.showTooltip = true
                                  },
                                  "mouse-leave": function($event) {
                                    _vm.showTooltip = false
                                  }
                                }
                              }),
                              _vm.showTooltip
                                ? _c("Tooltip", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.nameFromArray(user.FirstName)
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.nameFromArray(user.LastName)
                                        ) +
                                        " is currently editing the page. }. "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }